module.exports = __webpack_public_path__ + "img/xiaoren.74276e64.png";